import React from 'react'
import abhishek from '../../pages/about/abhishek.png'
import Hero from './Hero'
import About from './About'
function Abhishek() {
  return (
    <section className="container-fluid p-0">
        <Hero title="ABHISHEK" subtitle="Abhishek is a skilled senior video editor and camera operator who plays a pivotal role in managing complete production on shoot sets. Known for his discipline, hard work, and keen attention to detail, he ensures that every aspect of the production runs seamlessly and that all challenges are effectively tackled. With a background in mechanical engineering, Abhishek transitioned into video editing and filmmaking out of pure passion, turning it into a successful profession. His dedication to his craft, combined with his ability to adapt and deliver excellence under pressure, makes him an invaluable asset to any production team." image={abhishek}/>
        </section>
  )
}

export default Abhishek